<template>

    <div>
        <!-- İlgili Siparişler -->
        <campaign-list :addCategoryBtnShow="true" :params="params" :addBtnShow="addBtnControl" :multiBtnShow="false"></campaign-list>
        
    </div>
  </template>
  
  <script>
  import {
    BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
    BBadge, BDropdown, BDropdownItem, BPagination, BFormCheckbox, BTableLite, VBTooltip
  } from 'bootstrap-vue'
  import CampaignList from './Links.vue';
  export default {
    components: {
      
      BCard,
      BRow,
      BCol,
      BFormInput,
      BButton,
      BTable,
      BMedia,
      BAvatar,
      BLink,
      BBadge,
      BDropdown,
      BDropdownItem,
      BPagination,
      BFormCheckbox,
      BTableLite,
  
      CampaignList,
    },
    directives: {
      'b-tooltip': VBTooltip
    },
    data() {
        return {
            params:{
                filter:{
                    type:1,
                    platform_id:8,
                },
                multiLinks: true,
                source: 'list',
            },
        }
    },
    computed: {
      addBtnControl() {
        return  [
                'firma_paylasimi.sms_ekleyebilir_duzenleyebilir',
                'firma_paylasimi.whatsapp_ekleyebilir_duzenleyebilir',
                'firma_paylasimi.story_ekleyebilir_duzenleyebilir',
                'paylasimlar.fenomen_paylasimi_yapabilir_duzenleyebilir'
            ].some(p => this.$store.state.user.userData.permissions?.includes(p));
      }
    },
    mounted(){
    },
    methods: {
    },
    watch: {
    },
  }
  </script>
  
  <style lang="scss" scoped>
  .per-page-selector {
    width: 90px;
  }
  </style>
  